<!-- =========================================================================================
  File Name: InstituteEdit.vue
  Description: Institute Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-my-institute-edit">

    <vx-card title="학원 상세 정보" class="mb-base" v-if="institute_data">
      <my-institute-edit-form class="mt-4" :data="institute_data" />
    </vx-card>
  </div>
</template>


<script>
import MyInstituteEditForm  from './MyInstituteEditForm.vue'
import { fetchData } from '@/api/module'

export default {
  components: {
    MyInstituteEditForm
  },
  data () {
    return {
      institute_data: null
    }
  },
  methods: {
  },
  async created () {
    try {
      const { data } = await fetchData('/my-institute')
      this.institute_data = data.data
      
    } catch (error) {

      this.$vs.notify({
        title: 'Error',
        text: error.response.data.msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      }) 
    }
  }
}

</script>
